import { render, staticRenderFns } from "./product-details-form.vue?vue&type=template&id=832ec8c0&"
import script from "./product-details-form.vue?vue&type=script&lang=js&"
export * from "./product-details-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports